import { request } from "../../utils/config"

export const GET_USERS = async (params) => {
  const response = await request({
    params: params,
    url: `Users`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_PROFILE_PHOTO = async () => {
  const token = localStorage.getItem("accessToken")
  if (!token) return { PhotoUrl: "", FileName: "" }
  try {
    const response = await request({
      url: `Users/GetProfilePhoto`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (e) {
    return { PhotoUrl: "", FileName: "" }
  }
}
